export type SolveError = {
  ID: string;
  Label?: string;
  Summary?: number;
  Description?: string;
  Link?: string;
};

/**
 * HTTP Error Response Data from FOND API
 */
export interface HTTPErrorResponse {
  code: string;
  message: string;
}

/** HTTP Errors as thrown by RTK with a data attribute
 *
 * See {@link https://redux-toolkit.js.org/rtk-query/usage-with-typescript#type-safe-error-handling|rtk-query#FetchBaseQueryError}
 * for more details.
 */
export type BasicRtkHttpError = {
  status: number;
  data: HTTPErrorResponse;
};

/**
 * When an error is caught from an RTK call this function can be used to determine
 * if it is an basic HTTPError to narrow the type for further processing.
 *
 * @param error - a thrown error object
 */
export const isBasicRtkHttpError = (error: unknown): error is BasicRtkHttpError => {
  if (error && typeof error === "object" && "data" in error && isHttpErrorResponse(error.data)) {
    return true;
  }
  return false;
};

const isHttpErrorResponse = (errorData: unknown): errorData is HTTPErrorResponse => {
  return typeof errorData === "object" && errorData !== null && "code" in errorData && "message" in errorData;
};
